import StickyEvnegia from './StickyEvnegia';
export default StickyEvnegia;